<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <fa-icon [icon]="['fas', 'triangle-exclamation']"></fa-icon>
    <h2 ngpDialogTitle>
      {{
        (unreachable
          ? "server-fault-dialog.title.connection-problem"
          : "server-fault-dialog.title.server-error"
        ) | translate
      }}
    </h2>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="dismiss()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <sui-callout tone="danger" [icon]="['fas', 'circle-exclamation']">{{
      fault.message
    }}</sui-callout>

    <div class="server-fault__actions">
      <sui-button
        variant="ghost"
        [leadingIcon]="['fas', expanded() ? 'chevron-up' : 'chevron-down']"
        (click)="toggleDetails()"
      >
        {{
          (expanded()
            ? "server-fault-dialog.button.hide-details"
            : "server-fault-dialog.button.show-details"
          ) | translate
        }}
      </sui-button>
      @if (expanded()) {
        <sui-button
          variant="ghost"
          [leadingIcon]="['fas', 'copy']"
          (click)="copyDetails()"
        >
          {{
            (copied()
              ? "server-fault-dialog.button.copied"
              : "server-fault-dialog.button.copy-details"
            ) | translate
          }}
        </sui-button>
      }
    </div>
    @if (expanded()) {
      <pre class="server-fault__details">{{ detailsJson }}</pre>
    }
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button variant="primary" (click)="dismiss()">
      {{ "btn.close" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
